import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import './UserAdd.css';
import Tabbar from '../../../Components/Tabbar/Tabbar';
import { getAll, getRoles, add, getUserGroups, clearErrs } from '../../../Store/Actions/RestActions';
import UsersEditAddComponent from '../../../Components/Pages/UsersEditAddComponent';
import ErrorModal from '../../../Components/errorModal';

class UserAddPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountId: localStorage.getItem('accountId'),
      userName: '',
      firstName: '',
      lastName: '',
      notes: '',
      email: '',
      isAdmin: false,
      isSuperman: false,
      isProtected: false,
      isActive: true,
      isJunior: false,
      isSenior: false,
      roles: [],
      userGroupId: '',
      userGroup: '',
      formErrors: { email: '', password: '' },
      emailValid: false,
      passwordValid: false,
      formValid: false,
      showPassword: false,
    };
    this.form = true;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.toggleShowPassword = this.toggleShowPassword.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }
  componentDidMount() {
    this.props.usersFetch();
    this.props.rolesFetch();
    this.props.userGroupFetch();

  }
  handleSelectChange(event) {
    const target = event.target;
    const value = target.value;
    this.setState({ userGroup: value, userGroupId: value });
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState(
      { [name]: value },
      () => { this.validateField(name, value); },
    );
  }

  handleCheckboxChange(roles) {
    this.setState({ roles: roles });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.userAdd({
      UserName: this.state.userName, firstName: this.state.firstName, lastName: this.state.lastName, notes: this.state.notes, Password: this.state.password, IsProtected: this.state.isProtected, IsAdmin: this.state.isAdmin, IsSuperman: this.state.isSuperman, IsActive: this.state.isActive, Email: this.state.email, isJunior: this.state.isJunior, isSenior: this.state.isSenior, roles: this.state.roles, userGroupId: this.state.userGroupId, userGroup: this.state.userGroup
    });
  }

  validateField(fieldName, value) {
    const passwordRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    const emailRegex = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    const fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
    let passwordValid = this.state.passwordValid;

    switch (fieldName) {
      case 'email':
        emailValid = emailRegex.test(value);
        fieldValidationErrors.email = emailValid ? '' : ' is invalid';
        break;
      case 'password':
        passwordValid = passwordRegex.test(value);
        fieldValidationErrors.password = passwordValid ? '' : ' must be eight characters including one uppercase letter, one special character and alphanumeric characters.';
        break;
      default:
        break;
    }
    this.setState({
      formErrors: fieldValidationErrors,
      emailValid,
      passwordValid,
    }, this.validateForm);
  }

  validateForm() {
    this.setState({ formValid: this.state.emailValid && this.state.passwordValid });
  }

  toggleShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  render() {
    if (this.props.fireRedirect) {
      return (
        <Redirect to="/users" />
      );
    }
    return (
      <div className="container">
        <Tabbar setActiveTab="users" />
        <div className="contentBox tabbed-content-box addUser">
          <h3>Add User</h3>
          <UsersEditAddComponent
            {...this.props}
            state={this.state}
            handleInputChange={this.handleInputChange}
            handleCheckboxChange={this.handleCheckboxChange}
            handleSubmit={this.handleSubmit}
            toggleShowPassword={this.toggleShowPassword}
            addLabel
            passwordInput
            userGroup={
              { label: "User Group", items: this.props.userGroups, onChange: this.handleSelectChange, userGroupId: this.state.userGroupId }
            }
          />

        </div>
        <ErrorModal error={this.props.error} errMsg={this.props.errMsg} formError={this.props.formError} onClose={this.props.clearError}></ErrorModal>

      </div>
    );
  }
}
const mapStateToProps = state => ({
  users: state.users.data,
  roles: state.roles.data,
  userGroups: state.userGroups.data,
  fireRedirect: state.users.redirect,
  error: state.users.hasError,
  errMsg: state.users.errMsg
});
const mapDispatchtoProps = dispatch => ({

  userAdd: data => dispatch(add('users', data)),
  userGroupFetch: () => dispatch(getUserGroups('userGroups', {})),
  usersFetch: () => dispatch(getAll('users', {})),
  rolesFetch: () => dispatch(getRoles('roles', {})),
  clearError: () => dispatch(clearErrs('users'))
});
export default connect(mapStateToProps, mapDispatchtoProps)(UserAddPage);



// WEBPACK FOOTER //
// ./src/Pages/Users/UserAdd/UserAdd.js